import { signal } from '@preact/signals-react';

/**
 * DOM id cua card appointment tren calendar. Co tien to rieng de khong dung id cua o luoi
 * (`HH:mm/staffId`) va id cua dnd-kit.
 */
export const appointmentDomId = (aptId: string) => `apt-${aptId}`;

/** Lich vua duoc dat/sua, dang duoc lam noi bat. `Calendar/Body/Appointment.tsx` doc signal nay. */
export const focusedAppointmentId = signal<string | null>(null);

// Card chi xuat hien sau khi calendar da doi ngay, doi trang staff va render lai xong. Ban mot
// phat roi bo cuoc se truot khi mot trong nhung buoc do cham hon du kien, nen phai cho.
const WAIT_FOR_MOUNT_MS = 5000;
const POLL_MS = 100;
const HIGHLIGHT_MS = 3000;

let stopWaiting: (() => void) | null = null;
let highlightTimer: ReturnType<typeof setTimeout> | null = null;

const scrollToElement = (element: HTMLElement) =>
  element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });

const highlight = (aptId: string) => {
  focusedAppointmentId.value = aptId;
  if (highlightTimer) clearTimeout(highlightTimer);
  highlightTimer = setTimeout(() => {
    // Chi tat khi van con la lich minh bat len: mot focus moi hon duoc uu tien.
    if (focusedAppointmentId.value === aptId) focusedAppointmentId.value = null;
    highlightTimer = null;
  }, HIGHLIGHT_MS);
};

/**
 * Keo calendar toi lich vua dat/sua roi lam no noi bat.
 *
 * `fallbackCellId` la id o luoi (`HH:mm/staffId`) — dung khi card khong mang DOM id, vi du o
 * multi-booking dong dang hien hop tom tat thay vi tung card. Khong tim thay gi thi im lang,
 * dat lich van thanh cong.
 */
export const focusAppointment = (aptId?: string | null, fallbackCellId?: string) => {
  stopWaiting?.();
  stopWaiting = null;

  const scrollToFallback = () => {
    const cell = fallbackCellId ? document.getElementById(fallbackCellId) : null;
    if (cell) scrollToElement(cell);
  };

  if (!aptId) {
    scrollToFallback();
    return;
  }

  const deadline = Date.now() + WAIT_FOR_MOUNT_MS;
  let timer: ReturnType<typeof setTimeout> | null = null;
  stopWaiting = () => {
    if (timer) clearTimeout(timer);
  };

  const attempt = () => {
    const element = document.getElementById(appointmentDomId(aptId));
    if (element) {
      stopWaiting = null;
      scrollToElement(element);
      highlight(aptId);
      return;
    }
    if (Date.now() >= deadline) {
      stopWaiting = null;
      scrollToFallback();
      return;
    }
    timer = setTimeout(attempt, POLL_MS);
  };

  attempt();
};
